import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';

const Index = ({
  value,
  setValue,
  handleChange,
  dropdownId,
  placeholder,
  selectedId,
  setSelectedId,
  description,
  selectAllText,
  coteachertext
}) => {
  const [visible, setVisible] = useState(false);
  let display = '';
  switch (description) {
  case true:
    display = 'd-block';
    break;
  case false:
    display = 'd-none';
    break;
  default:
    display = 'd-none';
    break;
  }

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const closeChip = (event, id) => {
    event.stopPropagation();
    const dataValue = value.map((item) => (item.id === id ? { ...item, isChecked: false } : item));
    const dataSelectedId = selectedId.filter((item) => item !== id);
    setValue(dataValue);
    if (dataSelectedId.length === 0) setSelectedId('');
    else setSelectedId(dataSelectedId);
  };

  const menu = (
    <Menu style={{ width: '100%' }} multiple onSelect={handleChange} onDeselect={handleChange}>
      <MenuItem key="000">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={value.filter((item) => item?.isChecked !== true).length < 1}
            onChange={() => {}}
            name={`check-all-${selectAllText}`}
            id={`check-all-${selectAllText}`}
          />
          <div htmlFor={`check-all-${selectAllText}`}>{selectAllText}</div>
        </div>
      </MenuItem>
      {value.map((item, index) => (
        <MenuItem key={item.id}>
          <div className="form-check">
            <input
              key={`name${item.id}`}
              type="checkbox"
              className="form-check-input"
              checked={item.isChecked}
              name={'check-' + index}
              id={'check-' + index + item.id}
            />
            <div className="mb-0">
              <div htmlFor={'check-' + index}>
                {item.name}{' '}
                <>
                  {coteachertext ? (
                    <span className="text-danger">
                      {item.description.length > 0 ? item.description : ''}
                    </span>
                  ) : (
                    ''
                  )}
                </>
              </div>
              {!coteachertext ? (
                <>
                  <small className={display}>{item.description}</small>
                </>
              ) : (
                ''
              )}
            </div>
          </div>
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <div id={dropdownId}>
      <Dropdown
        trigger={['click']}
        onVisibleChange={handleVisibleChange}
        visible={visible}
        closeOnSelect={false}
        overlay={menu}
        overlayClassName='dropdown-style'
        animation="slide-up"
        getPopupContainer={() => document.getElementById(dropdownId)}>
        <div className="form-select form-chips d-flex align-items-center gap-2 flex-wrap overflow-auto">
          {(selectedId === null || selectedId?.length === 0) && (
            <div className="form-placeholder">{placeholder}</div>
          )}
          {selectedId?.length === value.length && value.length > 0 && (
            <div className="form-placeholder">{selectAllText}</div>
          )}
          {selectedId?.length > 0 &&
            selectedId?.length != value.length &&
            value
              .filter(item => selectedId.includes(item.id))
              .map((itemName) => (
                <span key={itemName?.id}>
                  {itemName.name}
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    className="ms-1"
                    id={`chip-${itemName?.name}-${itemName?.id}`}
                    onClick={(e) => closeChip(e, itemName.id)}
                  />
                </span>
              ))}
        </div>
      </Dropdown>
    </div>
  );
};

Index.propTypes = {
  value: PropTypes.array,
  setValue: PropTypes.func,
  handleChange: PropTypes.func,
  dropdownId: PropTypes.string,
  placeholder: PropTypes.string,
  selectedId: PropTypes.array,
  setSelectedId: PropTypes.func,
  description: PropTypes.bool,
  selectAllText: PropTypes.string,
  coteachertext: PropTypes.bool
};

export default Index;
